<template>
  <el-scrollbar class="repo_tree">
    <el-tree
      :data="materialTreeData"
      :props="defaultProps"
      @node-click="handleNodeClick"
      :highlight-current='hightLight'
      element-loading-text="拼命加载中"
      :expand-on-click-node='expandOnClick'
      v-loading="loading"
    ></el-tree>
  </el-scrollbar>
</template>

<script>
import * as api from '../../../api'
export default {
  name: 'repotree',
  props: {
    isHidePersonRepo: {
      type: Boolean,
      required: true
    },
  },
  components: {

  },
  mounted () {

  },
  created () {
    this.getMaterialData()
  },
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      hightLight: true,
      expandOnClick: true,
      materialTreeData: [],
      loading: false
    }
  },
  computed: {

  },
  methods: {
    handleNodeClick (data) {
      if (!data.flag_repo) {
        this.$emit('folderClick', data)
      }
    },
    //获取素材库列表
    getMaterialData () {
      this.loading = true
      var option = {
        ...this.$store.getters.baseOption,
        'params': {}
      }
      api._post(_MATTERREPOURL_ + 'get_repo_tree', option).then((resp) => {
        if (resp.code == 200) {
          this.materialTreeData = resp.data
          if (this.isHidePersonRepo) {
            for (var i = 0; i < this.materialTreeData.length; i++) {
              if (this.materialTreeData[i].id.indexOf('repository-personal') !== -1) {
                this.materialTreeData.splice(i, 1)
                break;
              }
            }
          }

        } else {
          this.materialTreeData = []
        }
        this.loading = false
      }).catch((error) => {
        this.materialTreeData = []
        this.loading = false
      })
    },
  }
}
</script>

<style lang='stylus' scoped>
.repo_tree
  width 100%
  height 92%
</style>
